import { render } from "./NewWebsitePopin.vue?vue&type=template&id=2aec9754&scoped=true&ts=true"
import script from "./NewWebsitePopin.vue?vue&type=script&lang=ts"
export * from "./NewWebsitePopin.vue?vue&type=script&lang=ts"

import "./NewWebsitePopin.vue?vue&type=style&index=0&id=2aec9754&lang=stylus"
import "./NewWebsitePopin.vue?vue&type=style&index=1&id=2aec9754&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aec9754"]])

export default __exports__